import React, { useState, useEffect, lazy, Suspense } from "react"
import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom';
import { lang, img_url } from '../components/lang'
import { useLocation } from "react-router-dom";
import api from '../components/api'
import styles from '../assets/css/article.module.css';
import FilterComponent from "../components/Place/FilterComponent";

const Nav = lazy(() => import ('../components/Template/Nav'))
const PlaceLists = lazy(() => import ('../components/Place/PlaceLists'))
const PlaceDetail = lazy(() => import ('../components/Place/PlaceDetail'))

export default function Place(props) {
    const [init, setInit] = useState([]);
	  const navigate = useNavigate();
    const [nav_data, setNavData] = useState([]);
    const [place, setPlace] = useState({});
    const search = useLocation().search;
    const params = new URLSearchParams(search);
    let keyword = (params.get('keyword'))?params.get('keyword'):'';
    let placeid = (params.get('id'))?params.get('id'):0;
    const [place_id, setPlaceID] = useState(placeid);
    const type_params = useParams();

    const [all_data, setAllData] = useState([]);
    const [listsdata, setListsdata] = useState([]);
    const [filterText, setFilterText] = useState(keyword);
    const [all_province, setAllProvince] = useState([]);

    const fetchInit = async () =>{
      try {
          const response = await api.get('/menu/3');
          setNavData(response.data);
          const ssresponse = await api.get('/setting');
          setInit(ssresponse.data.results);
      } catch (err) {
          if(err.response){
              //Not in 202 response range
              console.log(err.response.data);
              console.log(err.response.headers);
              console.log(err.response.status);
          } else {
              console.log(`Error: ${err.message}`);
          }
      }
  }

    useEffect(()=>{
      // console.log(place_id);;
        fetchInit();
        fetchData();
        window.addEventListener("scroll", reveal);
        reveal();

    },[]);

    useEffect(()=>{
      if(parseInt(place_id)>0){
        listsdata.forEach(element => {
          if(parseInt(element.id)===parseInt(place_id)){
            setPlace(element)
            // console.log(element);
          }
        });
      }
    },[place_id,listsdata]);

    function reveal() {
        var reveals = document.querySelectorAll(".reveal");
        for (var i = 0; i < reveals.length; i++) {
          var windowHeight = window.innerHeight;
          var elementTop = reveals[i].getBoundingClientRect().top;
          var elementVisible = 150;
          if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.add("active");
          } else {
            reveals[i].classList.remove("active");
          }
        }
    }

    const fetchData = async () =>{
      try {
        const response = await api.get('/place');
        let results = response.data.results;
        setAllProvince(response.data.address);
        setAllData(results);
        if(keyword){
            // console.log(txt,province,district)
            let filteredItems = results.filter(
              item => item.id.includes(keyword.toLowerCase()) || 
                      item.name.toLowerCase().includes(keyword.toLowerCase()) || 
                      item.address.toLowerCase().includes(keyword.toLowerCase()) || 
                      item.district.toLowerCase().includes(keyword.toLowerCase()) || 
                      item.sub_district.toLowerCase().includes(keyword.toLowerCase()) || 
                      item.province.toLowerCase().includes(keyword.toLowerCase()) || 
                      item.type_name.toLowerCase().includes(keyword.toLowerCase()) || 
                      item.era_name.toLowerCase().includes(keyword.toLowerCase()),
            );
            setListsdata(filteredItems);
        }else{
          setListsdata(results);
        }
      } catch (err) {
          if(err.response){
              //Not in 202 response range
              console.log(err.response.data);
              console.log(err.response.headers);
              console.log(err.response.status);
          } else {
              console.log(`Error: ${err.message}`);
          }
      }
    }
    
    const onFilter = (txt,province,district) => {  
      // console.log(txt,province,district)
      let filteredItems = all_data.filter(
          item => item.id.includes(txt.toLowerCase()) || 
                  item.name.toLowerCase().includes(txt.toLowerCase()) || 
                  item.address.toLowerCase().includes(txt.toLowerCase()) || 
                  item.district.toLowerCase().includes(txt.toLowerCase()) || 
                  item.sub_district.toLowerCase().includes(txt.toLowerCase()) || 
                  item.province.toLowerCase().includes(txt.toLowerCase()) || 
                  item.type_name.toLowerCase().includes(txt.toLowerCase()) || 
                  item.era_name.toLowerCase().includes(txt.toLowerCase()),
      );

      if(province&&province!==''){
        filteredItems = filteredItems.filter(item=>(parseInt(item.province)===parseInt(province)||parseInt(item.main_location_province)===parseInt(province)))
      }

      if(district&&district!==''){
        filteredItems = filteredItems.filter(item=>(parseInt(item.district)===parseInt(district)||parseInt(item.main_location_district)===parseInt(district)))
    }
      // console.log(filteredItems);
      setListsdata(filteredItems);
      setFilterText(txt);
      setPlaceID(0);
    }

    /* filter and clearfilter */
    const handleClear = () => {
        const txt = '';
        const filteredItems = all_data.filter(
            item => item.id.includes(txt.toLowerCase()) || 
            item.name.toLowerCase().includes(txt.toLowerCase()) || 
            item.address.toLowerCase().includes(txt.toLowerCase()) || 
            item.district.toLowerCase().includes(txt.toLowerCase()) || 
            item.sub_district.toLowerCase().includes(txt.toLowerCase()) || 
            item.province.toLowerCase().includes(txt.toLowerCase()) || 
            item.type_name.toLowerCase().includes(txt.toLowerCase()) || 
            item.era_name.toLowerCase().includes(txt.toLowerCase()),
        );
        setListsdata(filteredItems);
        setFilterText('');
    };

    return (
        <div className={"container "+styles["article-container"]}>
              <div className={styles["content"]+" reveal"}>
              <Nav styles={styles} nav_data={nav_data} />
                <article className={styles["article"]}>
                  <div className={styles["filter-box"]}>
                    <FilterComponent onFilter={onFilter} styles={styles} onClear={handleClear} setFilterText={setFilterText} filterText={filterText} />
                  </div>
                  {(place_id===0)?(
                    <Suspense fallback={<h1>Loading Locations</h1>}>
                        <PlaceLists styles={styles} setPlaceID={setPlaceID} setPlace={setPlace} all_province={all_province} listsdata={listsdata}/>
                    </Suspense>
                  ):(
                    <Suspense fallback={<h1>Loading Location</h1>}>
                        <PlaceDetail styles={styles} data={place}  setPlaceID={setPlaceID} setPlace={setPlace} place_id={place_id} all_province={all_province}/>
                    </Suspense>
                  )}
                  </article>
              </div>
        </div>
    )
}